/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { Buffer } from 'buffer';

/*
 Polyfill for Buffer, required for some libraries that expect it to be available.  Mainly used for exporting chat messages do Word.
 Need it to handle images.
 The @mohtasham/md-to-docx library, when processing images from URLs, relies on the Node.js Buffer API,
 which is unavailable in the browser environment. This is a browser-compatible implementation (a polyfill) for Buffer.
 */
(window as any).Buffer = Buffer;

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
